import { Button, Form, FormInstance, Input, message, Select, Space } from "antd";
import React, { useEffect, useState } from "react";
import {
  editMemberOfBranch,
  fetchAllBranches,
  fetchUserPermissions,
} from "../../../../apis/branch.api";
import { usePermissions } from "../../../../custom_hooks/permission/permission_hook";
const { Option } = Select;

const SubmitButton = ({
  form,
  loading,
}: {
  form: FormInstance;
  loading: boolean;
}) => {
  const [submittable, setSubmittable] = React.useState(false);
  const values = Form.useWatch([], form);

  React.useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => setSubmittable(true),
      () => setSubmittable(false)
    );
  }, [form, values]);

  return (
    <Button
      type="primary"
      htmlType="submit"
      disabled={!submittable || loading}
      loading={loading}
    >
      Submit
    </Button>
  );
};

const BranchMemberEditForm = (props: any) => {
  const [form] = Form.useForm();
  const { hasPermission } = usePermissions();
  const canEdit = hasPermission("branch_details.update");
  const [permissions, setPermissions] = useState([]);
  const [branches, setBranches] = useState<any[]>([]);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetchUserPermissions().then((result: any) => {
      setPermissions(result);
    });
    fetchAllBranches().then((result: any) => {
      setBranches(result);
    });
  }, []);

  useEffect(() => {
    Object.keys(props?.selected_member).forEach((key) => {
      form.setFieldsValue({
        [key]: props?.selected_member[key],
      });
    });
    const fName = props?.selected_member?.f_name ?? "";
    const lName = props?.selected_member?.l_name ?? "";
    form.setFieldsValue({ name: `${fName} ${lName}`.trim() });

    const branchVal = props?.selected_member?.branch;
    const firstBranchId = Array.isArray(branchVal)
      ? (typeof branchVal[0] === "object" ? branchVal[0]?.id : branchVal[0])
      : branchVal;
    if (firstBranchId !== undefined) {
      form.setFieldsValue({ branch: firstBranchId });
    }
  }, [props?.selected_member]);

  const onFinish = async (updatedValues: any) => {
    if (!canEdit) {
      message.error("You don't have permission to edit this member");
      return;
    }
    updatedValues["branch"] = [updatedValues?.branch];
    setSubmitting(true);
    try {
      const ok = await editMemberOfBranch(
        updatedValues,
        props?.selected_member?.id
      );
      if (ok) {
        message.success("Updated successfully");
        props?.onMemberEditDrawerClose();
      }
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <Form
      form={form}
      name="validateOnly"
      layout="vertical"
      autoComplete="off"
      onFinish={onFinish}
    >
      <Form.Item name="name" label="Name">
        <Input />
      </Form.Item>
      <Form.Item name="email" label="Email">
        <Input />
      </Form.Item>
      <Form.Item
        name="branch"
        label="Branch"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          placeholder="Select branch"
          options={branches?.map((branch) => ({
            label: branch?.branch_name,
            value: branch?.id,
          }))}
        />
      </Form.Item>
      <Form.Item
        name="contact"
        label="Phone Number"
        rules={[
          {
            required: true,
            pattern: /^[1-9]\d{9}$/gi,
            message: "Enter a valid phone number",
          },
        ]}
      >
        <Input disabled />
      </Form.Item>
      <Form.Item
        label="Permission"
        name={"user_permission"}
        rules={[
          {
            required: true,
            message: "Enter a valid user permission",
          },
        ]}
      >
        <Select placeholder="Select permission">
          {permissions?.map((each: any, index) => {
            let displayName = each?.permission_name;
            if (displayName === "customer_success") {
              displayName = "consultants";
            } else if (displayName === "retail") {
              displayName = "receptionist";
            }
            return (
              <Option key={index} value={each?.id}>
                {displayName}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
      <Form.Item>
        <Space>
          <SubmitButton form={form} loading={submitting} />
          <Button htmlType="reset">Reset</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default BranchMemberEditForm;
